import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import styled from "styled-components";
import { useEffect } from "react";
import { Text, Box } from "sprout-ui-primitives";
import { Button } from "sprout-ui-dom/dist/Button";
import { Page, Head } from "@sprout/client-layout";
import { abortAllTasks } from "@sprout/client-lib/dist/loading";
const StyledBox = styled(Box)`
  border-radius: 4px;
  border: 1px solid #c80000;
`;
const StyledPre = styled("pre")`
  white-space: pre-wrap;
`;
const showErrorStack = process.env.NODE_ENV === "development" || process.env.NODE_ENV === "test";
const Glitch = (props)=>{
    const { retry , error , info  } = props;
    useEffect(()=>{
        if (error) {
            console.error(error);
            if (window.Sentry) {
                const { Sentry  } = window;
                Sentry.withScope((scope)=>{
                    if (info) scope.setExtra("info", info);
                    Sentry.captureException(error);
                });
            }
        }
    }, [
        error,
        info
    ]);
    useEffect(()=>{
        abortAllTasks();
    }, []);
    if (error && showErrorStack) return /*#__PURE__*/ _jsx(_Fragment, {
        children: /*#__PURE__*/ _jsxs(StyledBox, {
            maxWidth: "100vw",
            maxHeight: "100vh",
            bg: "rgba(206, 17, 38, 0.05)",
            color: "#c80000",
            p: "16px",
            m: "32px",
            overflowX: "auto",
            children: [
                /*#__PURE__*/ _jsx(Text, {
                    mb: "16px",
                    fontSize: 3,
                    children: "Development-only debug information"
                }),
                /*#__PURE__*/ _jsx(Text, {
                    fontSize: 1,
                    lineHeight: "1.5",
                    children: /*#__PURE__*/ _jsx(StyledPre, {
                        children: /*#__PURE__*/ _jsx("code", {
                            children: error.stack
                        })
                    })
                })
            ]
        })
    });
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Head, {
                title: "Oops! | Sprout"
            }),
            /*#__PURE__*/ _jsx(Page, {
                variant: "shadow",
                fullHeight: false,
                maxWidth: 600,
                children: /*#__PURE__*/ _jsxs(Text, {
                    textAlign: "center",
                    children: [
                        /*#__PURE__*/ _jsx(Text, {
                            as: "h1",
                            fontSize: 5,
                            mt: "8px",
                            mb: "24px",
                            children: "Something unexpected happened"
                        }),
                        /*#__PURE__*/ _jsx(Text, {
                            as: "p",
                            mb: "48px",
                            children: `We've been notified of the issue and we're working on a solution!`
                        }),
                        /*#__PURE__*/ _jsx(Button, {
                            variant: "bright-blue",
                            as: "a",
                            href: "/",
                            children: "Take me home"
                        }),
                        retry && /*#__PURE__*/ _jsxs(_Fragment, {
                            children: [
                                /*#__PURE__*/ _jsx(Text, {
                                    my: "16px",
                                    color: "black.60",
                                    children: "or"
                                }),
                                /*#__PURE__*/ _jsx(Button, {
                                    variant: "bright-blue",
                                    onClick: retry,
                                    children: "Retry"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
export default Glitch;
